export enum ELoanStatus {
  NEW = 'New',
  CURRENT = 'Current',
  PAID_OFF = 'Paid Off',
  DELINQUET = 'Delinquent',
  COLLECTION = 'Collection',
  CANCELED = 'Canceled',
  CLOSED_FRAUD = 'Closed: Fraud',
  BANKRUPTCY = 'Bankruptcy',
}
